module.exports = __webpack_public_path__ + "img/answer-c4-1.232f22de.png";